import { array } from '@ember/helper';
import { guidFor } from '@ember/object/internals';
import Component from '@glimmer/component';

import themed from 'webapp/decorators/themed';
import joinClasses from 'webapp/helpers/join-classes';
import type { CheckboxItemInfo, SingleCheckboxValue } from 'webapp/components/form/checkbox';
import FormCheckboxComponent from 'webapp/components/form/checkbox';

export type GroupSelected = SingleCheckboxValue[];

interface Args {
	selected: GroupSelected;
	options: CheckboxItemInfo[];
	onChange: (value: GroupSelected) => void;
	name?: string;
	isDisabled?: boolean;
	theme?: string;
	size?: string;
}

interface FormCheckboxGroupComponentInterface<T> {
	Element: HTMLDivElement; // this is needed for ...attributes
	Args: T;
}

@themed()
export default class FormCheckboxGroupComponent extends Component<
	FormCheckboxGroupComponentInterface<Args>
> {
	guid = guidFor(this);

	declare theme: string; // from @themed
	declare size: string; // from @themed
	declare themeClass: string; // from @themed
	declare sizeClass: string; // from @themed

	get uniqueName() {
		return `${this.args.name || 'checkboxgroup'}-${this.guid}`;
	}

	get optionsCountClass() {
		const optCount = (this.args.options || []).length;
		return `opt-count-${optCount}`;
	}
	<template>
		<div
			...attributes
			class={{joinClasses
				(array "checkbox-group" this.themeClass this.sizeClass this.optionsCountClass)
			}}
		>
			{{#each @options as |option|}}
				<FormCheckboxComponent
					@name={{this.uniqueName}}
					@selected={{@selected}}
					@value={{option.value}}
					@label={{option.label}}
					@isDisabled={{option.disabled}}
					@isGroupDisabled={{@isDisabled}}
					@item={{option}}
					@theme={{this.theme}}
					@size={{this.size}}
					@onChange={{@onChange}}
				/>
			{{/each}}
		</div>
	</template>
}
